module.exports = __webpack_public_path__ + "static/media/Adora-Bouton.5578efd9.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/Adora-Bouton.otf
 ** module id = 878
 ** module chunks = 44
 **/